import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEstablishmentCompanies } from "@/features/companyBranches/hooks/useEstablishmentCompanies";
import { EstablishmentCompanyTransformer } from "@/features/companyBranches/services/establishmentCompanyTransformer";

const DashboardFilterEstablishmentBranchSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: establishmentBranchOptions,
  } = useEstablishmentCompanies({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer(),
    }),
  });

  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.EstablishmentBranch]}
      value={filters[DashboardFilters.EstablishmentBranch]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...establishmentBranchOptions]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.EstablishmentBranch]: value }))}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEstablishmentBranchSheet;
